import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercardinline = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 44 28",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("rect", {
				width: 9.393,
				height: 15.341,
				x: 17.306,
				y: 6.329,
				fill: "#FF5F00",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#EB001B",
				fillRule: "nonzero",
				d: "M18.2730847,14.000528 C18.2707263,11.0073751 19.6447615,8.17936073 21.9992828,6.33133486 C17.9993217,3.1877927 12.2552172,3.6456768 8.8037715,7.38319851 C5.35232582,11.1207202 5.35232582,16.8830457 8.8037715,20.6205674 C12.2552172,24.3580891 17.9993217,24.8159732 21.9992828,21.672431 C19.6440123,19.8238183 18.2698931,16.9946318 18.2730847,14.000528 Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#F79E1B",
				fillRule: "nonzero",
				d: "M36.9001312 20.6867668L36.9001312 19.8418661 37.0700825 19.8418661 37.0700825 19.667059 36.6655984 19.667059 36.6655984 19.8418661 36.8253526 19.8418661 36.8253526 20.6867668 36.9001312 20.6867668zM37.6853062 20.6867668L37.6853062 19.667059 37.5629412 19.667059 37.4201821 20.3954217 37.277423 19.667059 37.1550581 19.667059 37.1550581 20.6867668 37.2434328 20.6867668 37.2434328 19.9147023 37.3759948 20.5775124 37.4677685 20.5775124 37.6003305 19.9147023 37.6003305 20.6867668 37.6853062 20.6867668zM37.7848128 14.000528C37.7848128 17.735772 35.6519156 21.1430807 32.292195 22.7753569 28.9324745 24.4076332 24.9356867 23.9783094 21.9992828 21.6697211 24.3527766 19.8201263 25.7269153 16.9924879 25.7269153 13.999173 25.7269153 11.0058581 24.3527766 8.17821969 21.9992828 6.32862489 24.9356867 4.02003657 28.9324745 3.59071281 32.292195 5.22298906 35.6519156 6.85526531 37.7848128 10.262574 37.7848128 13.997818L37.7848128 14.000528z"
			})
		]
	})
});
export default SvgMastercardinline;
